<template>
  <div class="header-navbar-bg container-fluid p-0">
    <div class="container">
      <nav class="navbar navbar-expand-lg">
        <div class="container-fluid">
          <router-link
            class="navbar-brand p-0"
            :to="'/' + this.$store.state.langCodeX"
            ><img :src="this.$store.state.singleCompanyLogoX"
          /></router-link>

          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="material-icons menu">menu</span>
            <span class="material-icons close">close</span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :to="'/' + this.$store.state.langCodeX"
                  >{{
                    toTitles(this.$store.getters.getWordLocale("txt_anasayfa"))
                  }}</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :to="'/' + this.$store.state.langCodeX + '/about'"
                  >{{
                    toTitles(
                      this.$store.getters.getWordLocale("txt_hakkimizda")
                    )
                  }}</router-link
                >
              </li>

              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :to="
                    '/' +
                    this.$store.state.langCodeX +
                    '/' +
                    this.$store.state.singleCompanyUrlCountryX +
                    '/export-products/' +
                    this.$store.state.singleCompanyUrlNameX
                  "
                  >{{
                    this.$store.getters.getWordLocale("txt_urunlerimiz")
                  }}</router-link
                >
              </li>

              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :to="'/' + this.$store.state.langCodeX + '/contact'"
                  >{{
                    this.$store.getters.getWordLocale("txt_iletisim")
                  }}</router-link
                >
              </li>
            </ul>
            <ul
              class="navbar-nav mb-2 mb-lg-0 justify-content-center"
              style="flex-flow: wrap"
            >
              <li class="nav-item">
                <a
                  class="nav-link header-btn-link-bg"
                  data-bs-toggle="modal"
                  href="#exampleModalToggle"
                  v-on:click="clearSendingMessageForm(true)"
                  role="button"
                  >{{ toTitles(this.$store.getters.getWordLocale("txt_rfq")) }}
                  <span class="ms-1 material-icons-outlined"> email </span>
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle d-flex align-items-center p-0"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <country-flag
                    :country="
                      this.$store.state.langCodeX == 'en'
                        ? 'gb'
                        : this.$store.state.langCodeX == 'ar'
                        ? 'sa'
                        : this.$store.state.langCodeX
                    "
                    size="normal"
                  />
                  {{
                    this.$store.state.languagesNamesX.filter(
                      (q) => q.code == this.$store.state.langCodeX
                    )[0].name
                  }}
                </a>

                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li
                    v-for="(language, index) in this.$store.state
                      .domainLanguages"
                    :key="index"
                    v-show="language.LangCode != this.$store.state.langCodeX"
                  >
                    <a
                      class="dropdown-item d-flex align-items-center py-0"
                      href="#"
                      v-on:click="changeLanguage(language.LangCode)"
                    >
                      <country-flag
                        :country="
                          language.LangCode == 'en'
                            ? 'gb'
                            : language.LangCode == 'ar'
                            ? 'sa'
                            : language.LangCode
                        "
                        size="normal"
                        class="me-1"
                      />
                      {{
                        this.$store.state.languagesNamesX.filter(
                          (q) => q.code == language.LangCode
                        )[0].name
                      }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>

  <div
    class="modal fade"
    id="exampleModalToggle"
    aria-hidden="true"
    aria-labelledby="exampleModalToggleLabel"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog modal-lg rfq-modal"
    >
      <div class="modal-content">
        <div class="modal-body">
          <div class="d-flex justify-content-between rfq-modal-head">
            <h6>
              {{ this.$store.getters.getWordLocale("txt_rfq_gonder") }}
            </h6>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <form class="rfq-form">
            <div class="row">
              <div class="col-12 col-sm-6 mb-4">
                <input
                  type="text"
                  v-bind:class="{
                    'form-control': true,
                    'red-border': v$.form.nameSurname.$errors.length > 0,
                    'green-border':
                      userNameOut && v$.form.nameSurname.$errors.length == 0,
                  }"
                  v-on:focusout="validateNamesurname"
                  v-model="form.nameSurname"
                  :placeholder="
                    toTitles(this.$store.getters.getWordLocale('txt_ad_soyad'))
                  "
                />
                <div
                  class="form-error"
                  v-show="v$.form.nameSurname.$errors.length > 0"
                >
                  {{ this.$store.getters.getWordLocale("txt_adinizi_giriniz") }}
                </div>
              </div>
              <div class="col mb-4">
                <input
                  type="text"
                  @keyup="validateEmail"
                  v-on:focusout="validateEmail"
                  v-model="form.email"
                  v-bind:class="{
                    'form-control': true,
                    'red-border': v$.form.email.$errors.length > 0,
                    'green-border':
                      emailOut && v$.form.email.$errors.length == 0,
                  }"
                  :placeholder="
                    toTitles(this.$store.getters.getWordLocale('txt_eposta'))
                  "
                />
                <div
                  class="form-error"
                  v-show="v$.form.email.$errors.length > 0"
                >
                  {{
                    this.$store.getters.getWordLocale(
                      "txt_gecerli_eposta_adresi_giriniz"
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="mb-4">
              <vue-tel-input
                defaultCountry="tr"
                v-on:focusout="validatePhone"
                :validCharactersOnly="true"
                :value="form.phone"
                @input="onInput"
                :inputOptions="inputOptions"
                 v-bind:class="{
                  'form-control': true,
                  'red-border':
                    v$.form.phone.$errors.length > 0 || isPhoneValid == false,
                  'green-border':
                    phoneOut &&
                    v$.form.phone.$errors.length == 0 &&
                    isPhoneValid == true,
                }"
              ></vue-tel-input>

              <div
                class="form-error"
                v-show="
                  v$.form.phone.$errors.length > 0 || isPhoneValid == false
                "
              >
                {{
                  this.$store.getters.getWordLocale(
                    "txt_gecerli_telefon_giriniz"
                  )
                }}
              </div>
            </div>
            <div class="mb-4">
              <select
                v-model="form.country"
                v-bind:class="{
                  'form-select form-control': true,
                  'red-border': form.country == '' && submitted,
                  'green-border': form.country != 0,
                }"
                @change="setSelectedCountryId($event)"
              >
                <option
                  v-for="(country, ci) in countries"
                  :key="ci"
                  :value="country.code"
                  v-bind:class="{
                    disabled: country.id == 0,
                    selected: country.id == 0,
                  }"
                >
                  {{ country.text }}
                </option>
              </select>
              <div class="form-error" v-show="form.country == 0 && submitted">
                {{ this.$store.getters.getWordLocale("txt_please_select_country") }}
              </div>
            </div>
            <div class="mb-4">
              <input
                maxlength="250"
                minlength="5"
                v-on:focusout="validateSubject"
                v-model="form.subject"
                :placeholder="
                  toTitles(this.$store.getters.getWordLocale('txt_konu'))
                "
                type="text"
                v-bind:class="{
                  'form-select form-control': true,
                  'red-border': v$.form.subject.$errors.length > 0,
                  'green-border':
                    subjectOut && v$.form.subject.$errors.length == 0,
                }"
                id=""
              />
              <div
                class="form-error"
                v-show="v$.form.subject.$errors.length > 0"
              >
                {{ this.$store.getters.getWordLocale("txt_konu_giriniz") }}
              </div>

              <div
                v-bind:class="{
                  'float-end': true,
                  'mb-3': true,
                  'footer-color': form.subject.length != 250,
                }"
              >
                {{ form.subject.length }}/250
              </div>
              
            </div>
            <div class="mb-3">
              <textarea
                minlength="6"
                maxlength="700"
                v-on:focusout="validateMessage"
                v-model="form.message"
                v-bind:class="{
                  'form-select form-control': true,
                  'red-border': v$.form.message.$errors.length > 0,
                  'green-border':
                    messageOut && v$.form.message.$errors.length == 0,
                }"
                :placeholder="
                  toTitles(this.$store.getters.getWordLocale('txt_mesaj'))
                "
              ></textarea>
              <div
                class="form-error"
                v-show="v$.form.message.$errors.length > 0"
              >
                {{ this.$store.getters.getWordLocale("txt_mesaj_giriniz") }}
              </div>
              
              <div
                v-bind:class="{
                  'float-end': true,
                  'mb-3': true,
                }"
              >
                {{ form.message.length }}/700
              </div>              
            </div>
            <div
              class="
                d-flex
                justify-content-center justify-content-md-between
                w-100
              "
            >
              <div class="footer-file-box">
                <!--

               
              <a class="btn"
                ><i class="material-icons-outlined">attach_file</i> Attach</a
              >
               -->
              </div>

              <a
                href="javascript:;"
                v-on:click="submitForm"
                class="btn btn-light-primary"
                >{{ this.$store.getters.getWordLocale("txt_rfq_gonder") }}
                <span v-show="sendingMessage"
                  ><i class="fa fa-spinner fa-spin"></i
                ></span>
              </a>
            </div>
          </form>

          <div
            class="alert mt-3 alert-success text-center"
            v-show="messageSent"
          >
            <i class="fa fa-info-circle"></i>
            {{
              this.$store.getters.getWordLocale(
                "txt_mesajiniz_basariyla_gonderildi"
              )
            }}
          </div>

          <div
            class="alert mt-1 alert-danger text-center"
            v-show="errorSending"
          >
            <i class="fa fa-info-circle"></i>
            {{
              this.$store.getters.getWordLocale(
                "txt_mesaj_gonderirken_hata_olustu"
              )
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModalToggle2"
    aria-hidden="true"
    aria-labelledby="exampleModalToggleLabel2"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalToggleLabel2">Modal 2</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          Hide this modal and show the first with the button below.
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-primary"
            data-bs-target="#exampleModalToggle"
            data-bs-toggle="modal"
            data-bs-dismiss="modal"
          >
            Back to first
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.navbar-brand img {
  max-width: 100px;
  max-height: 39px;
}

.form-error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

@import "./style.css";
</style>

<script>
import CountryFlag from "vue-country-flag-next";
import useValidate from "@vuelidate/core";
import { required, email, minLength, maxLength } from "@vuelidate/validators";

import { VueTelInput } from "vue3-tel-input";
import "vue3-tel-input/dist/vue3-tel-input.css";

export default {
  data() {
    return {
      phoneOut: true,
      messageOut: false,
      subjectOut: false,
      emailOut: false,
      userNameOut: false,
      inputOptions: {
        placeholder: this.toTitles(
          this.$store.getters.getWordLocale("txt_telefon")
        ),
        autocomplete: "off",
        maxlength: 25,
        // showDialCode: true
      },
      ipAddress: "",
      errorSending: false,
      messageSent: false,
      sendingMessage: false,
      submitted: false,
      v$: useValidate(),
      form: {
        nameSurname: "",
        email: "",
        country: "",
        subject: "",
        message: "",
        phone: "",
      },
      countries: [],
      companyLogo: "",
      isPhoneValid: true,
    };
  },
  validations() {
    return {
      form: {
        nameSurname: { required },
        email: { required, email },
        phone: { required },
        country: { required },
        subject: { required, min: minLength(5), max: maxLength(250) },
        message: { required, min: minLength(6), max: maxLength(700) },
      },
    };
  },
  components: {
    VueTelInput,
    CountryFlag,
  },
  methods: {
    onInput(phone, phoneObject, input) {
      console.log(phone);
      console.log(input);

      if (phoneObject?.formatted) {
        this.isPhoneValid = phoneObject.valid;
        this.form.phone = phoneObject.number;
      }

      if (this.form.phone == undefined) {
        this.isPhoneValid = false;
      }
    },
    setSelectedCountryId(e) {
      this.form.country = e.target.value;
      this.validateCountry();
    },
    validateNamesurname() {
      this.v$.form.nameSurname.$validate();
    },
    validateCountry() {
      return !(this.form.country == "");
    },
    validateEmail() {
      this.emailOut =true;
      this.v$.form.email.$validate();
    },
    validatePhone() {
      this.phoneOut = true;
      this.v$.form.phone.$validate();
    },
    validateSubject() {
      this.subjectOut = true;
      this.v$.form.subject.$validate();
    },
    validateMessage() {
      this.messageOut = true;
      this.v$.form.message.$validate();
    },
    submitForm() {
      this.messageSent = false;
      this.errorSending = false;

      this.submitted = true;
      this.v$.$validate(); // checks all inputs
      if (!this.v$.$error) {
        this.getIpAddress();
      }
    },
    getIpAddress() {
      if (this.sendingMessage) {
        return 0;
      }

      if (this.isPhoneValid == false) {
        return 0;
      }

      this.sendingMessage = true;

      fetch("https://api.ipify.org?format=json")
        .then((x) => x.json())
        .then(({ ip }) => {
          this.ipAddress = ip;
          this.sendMessage();
        });
    },
    async sendMessage() {
      this.messageSent = false;
      this.errorSending = false;

      var result = [];
      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/home/SendRfqFromDomains/?name=${this.form.nameSurname}&subject=${this.form.subject}&message=${this.form.message}&countryCode=${this.form.country}&email=${this.form.email}&companyName=&fax=&phone=${this.form.phone}&webSite=&ipAddress=${this.ipAddress}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
            companyId: this.$store.state.singleCompanyIdX,
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.sendingMessage = false;
      if (result.outputType == "success") {
        this.messageSent = true;
        this.clearSendingMessageForm(false);
      } else {
        this.errorSending = true;
      }
    },
    clearSendingMessageForm(fromClick) {
      if (fromClick) {
        this.errorSending = false;
        this.messageSent = false;
      }

      this.messageSent = false;
      this.errorSending = false;

      this.form.nameSurname = "";
      this.form.email = "";
      this.form.phone = "";
      this.form.country = "";
      this.form.subject = "";
      this.form.message = "";
      this.submitted = false;

      this.userNameOut = false;
      this.emailOut = false;
      this.form.country = "";
      this.subjectOut = false;
      this.messageOut = false;
      this.phoneOut = false;

      this.v$.$reset();
    },

    async getCountries() {
      var tempList = [];

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCountries`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (tempList = data))
        .catch((err) => console.log(err.message));

      this.$store.state.fullCountriesX = tempList;
      this.buildCountriesInfo(this.$store.state.fullCountriesX);
    },
    buildCountriesInfo(vatiable) {
      vatiable.forEach((element) => {
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        this.countries.push({
          text: name,
          code: element.CountryCode,
          id: parseInt(element._id),
          flag: element.Flag,
        });
      });

      this.countries.unshift({
        text: this.$store.getters.getWordLocale("txt_ulke_sec"),
        code: "",
        id: 0,
        flag: "",
      });
    },
    changeLanguage(langCode) {
      this.$store.state.langCodeX = langCode;
    },
    toTitles(s) {
      return s.replace(/\w\S*/g, function (t) {
        return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
      });
    },
  },

  mounted() {
    if (this.$store.state.fullCountriesX.length == 0) {
      this.getCountries();
    } else {
      this.buildCountriesInfo(this.$store.state.fullCountriesX);
    }

    this.companyLogo =
      this.$store.state.singleCompanyDetailsX.Logo == null
        ? this.$store.state.defaultLogoX
        : `https://cdn.turkishexporter.com.tr${this.$store.state.singleCompanyDetailsX.Logo}`;
  },
};
</script>

<style scoped>
.red-border {
  border-color: #e1000f !important;
}

.green-border {
  border-color: #99c99b !important;
}
</style>